/**
 * PDF generation fix bundle identifier.
 * Grep the console for `PDF_GENERATION_BUILD_ID` to confirm which frontend build is running.
 */
export const PDF_GENERATION_BUILD_ID = "pdf-gen-fix-2026-06-22f";

/** Human-readable list of fixes included in this build (keep in sync with branch changes). */
export const PDF_GENERATION_FIXES = [
  "sentry-disabled-on-pdf-route",
  "sentry-envelope-excluded-from-api-tracker",
  "skip-listAllReports-on-pdf-route",
  "content-blocker-fields-in-ready-monitor-status",
  "image-proxy-token-for-pdf-img-tags",
  "sync-pdf-ready-pending-on-clear",
  "flat-blocker-warn-logging",
  "pending-image-complete-not-zero-width",
  "tiptap-html-image-proxy",
  "sso-session-image-blob-fetch",
] as const;

export type PdfGenerationFixId = (typeof PDF_GENERATION_FIXES)[number];

interface PdfGenerationBuildInfo {
  buildId: string;
  fixes: PdfGenerationFixId[];
  source: string;
  pathname: string;
  loggedAt: string;
}

declare global {
  interface Window {
    __PDF_GENERATION_BUILD__?: PdfGenerationBuildInfo;
  }
}

/**
 * Logs the PDF generation build id and exposes it on `window.__PDF_GENERATION_BUILD__`.
 */
export function logPdfGenerationBuild(source: string): void {
  if (typeof window === "undefined") return;

  const info: PdfGenerationBuildInfo = {
    buildId: PDF_GENERATION_BUILD_ID,
    fixes: [...PDF_GENERATION_FIXES],
    source,
    pathname: window.location.pathname,
    loggedAt: new Date().toISOString(),
  };

  window.__PDF_GENERATION_BUILD__ = info;

  console.info(
    `[PDF Generation] build=${PDF_GENERATION_BUILD_ID} source=${source} path=${info.pathname}`,
    { fixes: info.fixes }
  );
}
